var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0188 27.4648V32.3776L24.4667 31.4206L21.9146 32.3776L19.3626 31.4206L16.8105 32.3776L14.2584 31.4206L11.7064 32.3776L9.15428 31.4206L6.6022 32.3776V4.04947M4.17773 1.625H24.5303C25.9009 1.625 27.0188 2.74287 27.0188 4.11346V13.1094",
    stroke: "#0B8080",
    strokeWidth: 1.75,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4297 9.28135H18.1497M21.9778 9.28135H23.19M10.4297 13.1095H18.1497M10.4297 16.9376H18.1497M10.4297 20.7657H17.5117M10.4297 5.45317H18.1497M21.9778 5.45317H23.19M10.4297 24.5937H18.1497M4.11327 1.625C5.48182 1.625 6.60154 2.74472 6.60154 4.11327V11.5781H1.625V4.11327C1.625 2.74472 2.74472 1.625 4.11327 1.625Z",
    stroke: "#0B8080",
    strokeWidth: 1.75,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2373 25.4544C33.0901 22.6015 33.0901 17.976 30.2371 15.1231C27.3841 12.2703 22.7587 12.2704 19.9058 15.1233C17.0529 17.9763 17.053 22.6018 19.906 25.4546C22.7589 28.3075 27.3844 28.3074 30.2373 25.4544Z",
    stroke: "#0B8080",
    strokeWidth: 1.75,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1563 17.3125H24.9962C24.233 17.3125 23.6113 17.9329 23.6113 18.7022C23.6113 19.2398 23.896 19.7005 24.3769 19.9409L25.8569 20.6809",
    stroke: "#0B8080",
    strokeWidth: 1.75,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9863 23.2663H25.1464C25.9096 23.2663 26.5313 22.6459 26.5313 21.8766C26.5313 21.339 26.2466 20.8783 25.7658 20.6379L24.2858 19.8979M25.0717 17.3156V16.4922M25.0717 24.0897V23.2663",
    stroke: "#0B8080",
    strokeWidth: 1.75,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.370ed82a144ba0d95a1e0cda7e154d68.svg";
export { ForwardRef as ReactComponent };